import {
  getAllTimezoneIdentifiersByArea,
  getTimezoneCities,
  getTimezoneData,
} from '@chilipiper/date-time'
import { startSpan } from '@chilipiper/sentry'

type TimezoneOption = {
  area?: string
  label: string
  labelComponents?: {
    abbreviation?: string
    cities?: string
    currentTime?: string
    name?: string
    offset?: string
  }
  offset?: string
  value: string
}

export const getCurrentTime = (time: Date, locale: string, timezone: string) => {
  try {
    return time.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezone,
    })
  } catch (e) {
    console.error(e)
    return 'Unknown'
  }
}

export const areasOrder = [
  'US & Canada',
  'Europe',
  'Asia',
  'Oceania',
  'Africa',
  'South America',
  'North America',
  'Antarctica',
  'UTC',
]

export const getTimeZoneOptions = (locale?: string, showFullTimezone?: boolean) => {
  const result = startSpan(
    {
      name: 'timezone-list getTimeZoneOptions',
      attributes: {
        locale,
        showFullTimezone,
      },
    },
    () => {
      const now = new Date()

      return Object.entries(getAllTimezoneIdentifiersByArea())
        .sort(([areaA], [areaB]) => areasOrder.indexOf(areaA) - areasOrder.indexOf(areaB))
        .map(([area, timezones]) => {
          return {
            label: area,
            id: area + '_category',
            zones: timezones,
          }
        })
        .reduce((acc, next) => {
          const areaOptions = next.zones
            .map(zone => {
              const cities = getTimezoneCities(zone)?.join(', ') ?? ''
              const timezoneData = getTimezoneData(zone, now)
              let labelComponents: TimezoneOption['labelComponents'] = {}
              let fullLabel = `Missing timezone data - ${zone} - ${cities}`

              if (timezoneData) {
                const { abbreviation, offset, name } = timezoneData
                const currentTime = getCurrentTime(now, locale?.replace('_', '-') ?? 'en-US', zone)
                labelComponents = { abbreviation, cities, currentTime, name, offset }
                fullLabel = `${abbreviation} ${offset} ${name} - ${cities} ${currentTime}`
              }

              return {
                area: next.label,
                label: fullLabel,
                labelComponents,
                offset: timezoneData?.offset ?? '',
                value: zone,
              }
            })
            .sort((a, b) => {
              return Number(a.offset.replace(':', '')) - Number(b.offset.replace(':', ''))
            })

          acc.push(...areaOptions)
          return acc
        }, [] as TimezoneOption[])
    }
  )

  return result
}
